import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  useLocation, useNavigate,
} from 'react-router-dom';
import {
  Box, Button,
  Card, CardActionArea, CardContent, Grid, TextField, Tooltip, Typography,
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import PropTypes from 'prop-types';

import iconedit from '../../assets/icons/iconedit.png';
import kamiprueba from '../../assets/img/bot-kami.png';
import { GetNotesByLesson, UpdateNote } from '../../services/courses';
import { setAnalytics } from '../../utils';
import TransitionsModal from '../General/TransitionsModal';

import SkeletonAllNotes from './SkeletonAllNotes';

const useStyles = makeStyles((theme) => ({
  cardContent: {
    background: theme.palette.text.blue,
    color: theme.palette.common.white,
    borderRadius: '16px',
  },
  boxContent: {
    padding: theme.spacing(2, 2),
  },
  dialog: {
    background: theme.palette.common.grayLight,
    '& .MuiPaper-root': {
      background: 'transparent',
    },
  },
  dialogContent: {
    background: theme.palette.background.card,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: theme.spacing(5, 6),
    borderRadius: 16,
  },
  containerSectionBot: {
    width: '40%',
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2, 1),
  },
  containerSectionInfo: {
    width: '70%',
  },
  textTareaContent: {
    borderRadius: '14px',
    padding: theme.spacing(1, 1),
    margin: theme.spacing(0, 0, 0),
    textAlign: 'center',
    fontSize: 14,
    fontFamily: 'Raleway',
  },
  cardContainerInput: {
    background: '#F4F4F4',
    padding: theme.spacing(0, 1),
    margin: theme.spacing(1, 1),
    borderRadius: '12px',
  },
  textContent: {
    color: theme.palette.text.default,
    textAlign: 'start',
    fontSize: 14,
    fontFamily: 'Raleway',
  },
  cardContentDialog: {
    width: '35vw',
    height: '10vw',
  },
  container: {
    color: theme.palette.background.card,
    padding: theme.spacing(2, 3),
    borderRadius: '10px',
    width: '525px',
    height: '228px',
  },
  containerButton: {
    background: theme.palette.background.secondary,
    padding: theme.spacing(1, 2),
    borderRadius: '8px',
    marginLeft: theme.spacing(2),
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
  },
  iconClose: {
    alignItems: 'end',
  },
  textBtnSave: {
    color: theme.palette.text.default,
    textAlign: 'start',
    fontSize: 14,
    fontFamily: 'Raleway',
  },
  closeIcon: {
    color: theme.palette.text.blue,
    fontSize: 18,
    alignSelf: 'flex-end',
    margin: 5,
  },
  containerNoneNotes: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(7, 2),
  },
  containerNoneNotesImg: {
    width: 190,
  },
  containerNoneNotesText: {
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
    fontSize: 30,
    textAlign: 'center',
    margin: theme.spacing(0, 0, 3, 0),
  },
  containerNoneNotesTextContainer: {
    width: 550,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    margin: theme.spacing(0, 8),
  },
}));

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: theme.shadows[1],
    fontSize: 11,
    fontFamily: 'Raleway',
  },
}))(Tooltip);

function CardNotes({ note, getNotesByLesson }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [updateNoteLesson, setUpdateNoteLesson] = useState('');
  const [isChange, setIsChange] = useState(true);

  const handleClickOpen = (text) => {
    setOpen(true);
    setUpdateNoteLesson(text);
  };

  const handleClose = () => {
    setOpen(false);
    setIsChange(true);
  };
  const handleCloseModal = () => {
    setOpenConfirm(false);
  };
  const handleChangeEditNote = (event) => {
    setIsChange(false);
    setUpdateNoteLesson(event.target.value);
  };

  const updateNoteByLesson = async () => {
    await UpdateNote(note.id, updateNoteLesson);
  };

  const saveEditNote = async () => {
    setOpen(false);
    setIsChange(true);
    setOpenConfirm(true);
    updateNoteByLesson();
    await getNotesByLesson();
    setAnalytics('Notes', 'Modal_GuardarNotaEditada');
  };
  const styleIconModal = (e) => (<CheckCircleOutlineRoundedIcon className={e} />);
  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="stretch"
      >
        <Grid item xs={10}>
          <Box className={classes.boxContent}>
            <Card className={classes.cardContent}>
              <CardContent className={classes.textContent}>
                {note.text}
              </CardContent>
            </Card>
          </Box>
        </Grid>
        <Grid
          item
          xs={2}
          container
          direction="row"
        >
          <Box className={classes.boxContent}>
            <LightTooltip title="Editar nota">
              <Button onClick={() => handleClickOpen(note.text)}>
                <img src={iconedit} alt="gifEvaluation" />
              </Button>
            </LightTooltip>
          </Box>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        closeAfterTransition
      >
        <Box className={classes.cardContainerInput}>
          <Grid
            container
            direction="column"
            justifyContent="right"
            alignItems="right"
            spacing={1}
          >
            <Close className={classes.closeIcon} onClick={() => handleClose()} />

          </Grid>

          <Box className={classes.cardContainerInput}>
            <TextField
              onChange={handleChangeEditNote}
              value={updateNoteLesson}
              defaultValue={note.text}
              className={classes.textTareaContent}
              fullWidth
              multiline
              minRows={5}
              variant="outlined"
            />
            <CardActionArea>
              <Button variant="contained" onClick={saveEditNote} className={classes.containerButton} disabled={isChange}>
                Guardar
              </Button>
            </CardActionArea>
          </Box>
        </Box>
      </Dialog>
      <TransitionsModal
        open={openConfirm}
        handleClose={handleCloseModal}
        textBody="¡Tu nota se ha modificado con éxito!"
        icon={styleIconModal}
      />
    </>

  );
}
CardNotes.propTypes = {
  note: PropTypes.PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string]),
  ).isRequired,
  getNotesByLesson: PropTypes.func.isRequired,
};

function NotesForLesson() {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const [notesByLesson, setNotesByLesson] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { sub } = useSelector((store) => store.login);

  const getNotesByLesson = async () => {
    const notesContentByLesson = await GetNotesByLesson(
      sub,
      location.state.idLesson,
    );
    const notes = notesContentByLesson.data;
    setNotesByLesson(notes);
    setIsLoading(false);
  };

  const handleNavigateToCourses = () => navigate('/home');

  useEffect(() => {
    getNotesByLesson();
  }, [notesByLesson]);

  return (
    <Box>
      <Grid
        direction="row"
        justifyContent="space-between"
      />
      {
        isLoading
          ? (
            <SkeletonAllNotes />
          ) : (
            notesByLesson.length === 0 ? (
              <Box className={classes.containerNoneNotes}>
                <Box>
                  <img
                    src={kamiprueba}
                    alt="kamibot"
                    className={classes.containerNoneNotesImg}
                  />

                </Box>
                <Box className={classes.containerNoneNotesTextContainer}>
                  <Typography className={classes.containerNoneNotesText}>
                    Todavía no has creado notas
                    dentro de esta lección
                  </Typography>
                  <Box>
                    <Button variant="contained" color="secondary" onClick={handleNavigateToCourses}>IR A CURSOS</Button>
                  </Box>
                </Box>
              </Box>
            )
              : notesByLesson.sort((a, b) => (a.createdAt - b.createdAt)).map((note) => (
                <CardNotes key={note.id} note={note} getNotesByLesson={getNotesByLesson} />
              ))
          )
      }
      <Grid />

    </Box>

  );
}

export default NotesForLesson;
